import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { getCookie } from '@beef/utils';
import { currentStateList } from "../../../constants/state";
import { getGAClientId, pushBackCallAction } from "../../../utils/ga";
import { successfullFTTBFormSubmissionMT, successfullFTTBFormSubmissionVK } from "../../../utils/analytics/pixelAnalytics";
import { callbackFormClickYM } from "../../../utils/analytics/tariffsYandexMetrica";
import submitCallbackRequest from "../../../store/services/submitCallbackRequest";
import { store } from "../../../store";
import { CAPTCHA_STATUS, CaptchaWithCallbackPopupHOC } from "../hoc/CaptchaWithCallbackPopupHOC";
import { RenderPopupFormsNewDesign, RenderPopupFormsOld } from "./components";
var BackCallPopupLayout = function BackCallPopupLayout(_ref) {
  var onClose = _ref.onClose,
    isOpen = _ref.isOpen,
    phoneInputValue = _ref.phoneInputValue,
    changePhone = _ref.changePhone,
    showAbbreviatedPopup = _ref.showAbbreviatedPopup,
    data = _ref.data,
    redesign = _ref.redesign,
    isFMC = _ref.isFMC,
    isFttbTv = _ref.isFttbTv,
    showCaptcha = _ref.showCaptcha,
    captchaToken = _ref.captchaToken,
    changeCaptchaToken = _ref.changeCaptchaToken,
    changeCaptchaState = _ref.changeCaptchaState,
    reCaptchaModel = _ref.reCaptchaModel,
    captchaStatus = _ref.captchaStatus,
    changeCaptchaStatus = _ref.changeCaptchaStatus,
    captchaMsg = _ref.captchaMsg,
    changeCaptchaMsg = _ref.changeCaptchaMsg,
    forceShowBackCallPopup = _ref.forceShowBackCallPopup,
    analyticTariffDetails = _ref.analyticTariffDetails,
    marketingProductName = _ref.marketingProductName,
    productInacId = _ref.productInacId,
    isIcon = _ref.isIcon,
    isConvergent = _ref.isConvergent,
    caseTitle = _ref.caseTitle,
    renderRequestStatusPopup = _ref.renderRequestStatusPopup,
    captchaKey = _ref.captchaKey,
    analyticsOnFocus = _ref.analyticsOnFocus,
    analyticsOnSubmit = _ref.analyticsOnSubmit,
    isCheckboxChecked = _ref.isCheckboxChecked,
    isPersonalVerificationCheckboxEnable = _ref.isPersonalVerificationCheckboxEnable,
    changeCheckbox = _ref.changeCheckbox;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    phoneInputStatus = _useState2[0],
    setPhoneInputStatus = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState(showAbbreviatedPopup ? currentStateList.abbreviated : currentStateList.none),
    _useState6 = _slicedToArray(_useState5, 2),
    currentState = _useState6[0],
    setCurrentState = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isCheckboxError = _useState8[0],
    setCheckboxError = _useState8[1];
  var getGaType = function getGaType() {
    if (isFMC) return 'fmc';
    if (isFttbTv) return 'fttbTv';
    return 'fttb';
  };
  useEffect(function () {
    if (!data || !data.texts) return;
    if (isOpen) {
      sessionStorage.setItem('backCallPopupIsShown', '1');
    }
    if (showCaptcha) {
      pushBackCallAction('captcha', getGaType());
    }
    if (renderRequestStatusPopup) {
      setCurrentState(renderRequestStatusPopup);
    }
  }, []);
  var handleClosePopup = useCallback(function () {
    setCurrentState(currentStateList.none);
    onClose();
  }, []);
  var onPhoneFocus = function onPhoneFocus() {
    setPhoneInputStatus(null);
    analyticsOnFocus === null || analyticsOnFocus === void 0 || analyticsOnFocus();
  };
  var sendSuccessSubmitAnalytics = function sendSuccessSubmitAnalytics() {
    var additionalData = {
      clientType: 'B2C',
      ordered_itemTitle: 'Общий',
      ordered_itemProduct: getGaType()
    };
    var clientCTN = getCookie('USSS_gaUID');
    if (clientCTN) {
      additionalData = _objectSpread(_objectSpread({}, additionalData), {}, {
        clientCTN: clientCTN
      });
    }
    /**
     инфа о тарифе, может перезаписывать дефолтные значения
     */
    if (analyticTariffDetails) {
      additionalData = _objectSpread(_objectSpread({}, additionalData), analyticTariffDetails);
    }
    pushBackCallAction('send', 'url', additionalData);
  };
  var onBackCallBtnClick = function onBackCallBtnClick() {
    if (phoneInputValue.length !== 10) {
      setPhoneInputStatus('fail');
      return;
    }
    if (!isCheckboxChecked && isPersonalVerificationCheckboxEnable) {
      return;
    }
    setCheckboxError(false);
    analyticsOnSubmit === null || analyticsOnSubmit === void 0 || analyticsOnSubmit();
    var clientId = null;
    if (forceShowBackCallPopup) {
      clientId = getGAClientId();
    }
    setPhoneInputStatus(null);
    if (redesign) {
      setLoading(true);
    }
    if (!redesign) {
      setCurrentState(currentStateList.loading);
    }
    var captchaData = {
      captchaToken: captchaToken,
      key: captchaKey
    };
    submitCallbackRequest({
      phoneNumber: "+7".concat(phoneInputValue),
      captchaData: captchaData,
      isFMC: isFMC,
      clientId: clientId,
      marketingProductName: marketingProductName,
      productInacId: productInacId,
      caseTitle: caseTitle
    }).then(function (result) {
      var shouldShowCaptcha = result.shouldShowCaptcha,
        isCaptchaError = result.isCaptchaError,
        isSucceeded = result.isSucceeded;
      changeCaptchaState(false);
      if (redesign) {
        setLoading(false);
      }
      if (isSucceeded) {
        setCurrentState(currentStateList.success);
        changeCaptchaState(shouldShowCaptcha);
        sendSuccessSubmitAnalytics();
        callbackFormClickYM(isIcon, isConvergent);
        successfullFTTBFormSubmissionVK();
        successfullFTTBFormSubmissionMT();
      } else if (isCaptchaError) {
        changeCaptchaStatus(shouldShowCaptcha ? CAPTCHA_STATUS.fail : CAPTCHA_STATUS.success);
        changeCaptchaState(shouldShowCaptcha);
        setCurrentState(currentStateList.captcha);
      } else {
        setCurrentState(currentStateList.fail);
        pushBackCallAction('sendError', getGaType());
      }
    }).catch(function (err) {
      console.error(err);
      pushBackCallAction('sendError', getGaType());
      setCurrentState(currentStateList.fail);
    });
  };
  var onChangeCheckboxHandler = function onChangeCheckboxHandler(value) {
    changeCheckbox(value);
  };
  var renderFormsData = useMemo(function () {
    return {
      texts: data === null || data === void 0 ? void 0 : data.texts,
      phoneInputValue: phoneInputValue,
      changePhone: changePhone,
      showCaptcha: showCaptcha,
      captchaToken: captchaToken,
      changeCaptchaToken: changeCaptchaToken,
      reCaptchaModel: reCaptchaModel,
      captchaStatus: captchaStatus,
      changeCaptchaStatus: changeCaptchaStatus,
      phoneInputStatus: phoneInputStatus,
      onPhoneFocus: onPhoneFocus,
      onBackCallBtnClick: onBackCallBtnClick,
      changeCheckbox: onChangeCheckboxHandler,
      captchaMsg: captchaMsg,
      changeCaptchaMsg: changeCaptchaMsg,
      isCheckboxChecked: isCheckboxChecked,
      isPersonalVerificationCheckboxEnable: isPersonalVerificationCheckboxEnable,
      isCheckboxError: isCheckboxError
    };
  }, [phoneInputValue, changePhone, showCaptcha, captchaToken, changeCaptchaState, captchaMsg, isCheckboxChecked, changeCheckbox, isCheckboxError, isPersonalVerificationCheckboxEnable]);
  return redesign ? /*#__PURE__*/React.createElement(RenderPopupFormsNewDesign, {
    closePopup: handleClosePopup,
    data: renderFormsData,
    isLoading: isLoading,
    isOpen: isOpen,
    renderPopup: currentState,
    "data-t-id": "legacy-BackCallPopup"
  }) : /*#__PURE__*/React.createElement(RenderPopupFormsOld, {
    closePopup: handleClosePopup,
    data: renderFormsData,
    isOpen: isOpen,
    renderPopup: currentState
  });
};
BackCallPopupLayout.propTypes = process.env.NODE_ENV !== "production" ? {
  data: PropTypes.shape({
    texts: PropTypes.shape({})
  }),
  isOpen: PropTypes.bool,
  isIcon: PropTypes.bool,
  isFMC: PropTypes.bool,
  isFttbTv: PropTypes.bool,
  forceShowBackCallPopup: PropTypes.bool,
  onClose: PropTypes.func,
  redesign: PropTypes.bool,
  /* from ReCapthchaAndPhoneHOC */
  reCaptchaModel: PropTypes.shape({
    onChange: PropTypes.func,
    refreshCaptcha: PropTypes.number,
    setCaptchaKey: PropTypes.func
  }),
  captchaStatus: PropTypes.string,
  renderRequestStatusPopup: PropTypes.string,
  changeCaptchaStatus: PropTypes.func,
  captchaMsg: PropTypes.string,
  changeCaptchaMsg: PropTypes.func,
  captchaKey: PropTypes.string,
  showCaptcha: PropTypes.bool,
  captchaToken: PropTypes.string,
  changeCaptchaToken: PropTypes.func,
  changeCaptchaState: PropTypes.func,
  changePhone: PropTypes.func,
  phoneInputValue: PropTypes.string,
  marketingProductName: PropTypes.string,
  productInacId: PropTypes.string,
  showAbbreviatedPopup: PropTypes.bool,
  isConvergent: PropTypes.bool,
  caseTitle: PropTypes.string,
  analyticTariffDetails: PropTypes.shape({}),
  analyticsOnFocus: PropTypes.func,
  analyticsOnSubmit: PropTypes.func,
  isCheckboxChecked: PropTypes.bool,
  isPersonalVerificationCheckboxEnable: PropTypes.bool,
  changeCheckbox: PropTypes.func
} : {};
export var BackCallPopup = function BackCallPopup(props) {
  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(CaptchaWithCallbackPopupHOC, _extends({}, props, {
    "data-t-id": "legacy-BackCallPopup"
  }), /*#__PURE__*/React.createElement(BackCallPopupLayout, {
    "data-t-id": "legacy-BackCallPopup"
  })));
};
export default BackCallPopup;